.sidebar {
  width: var(--sidebar-width);
  height: calc(100vh - var(--navbar-height));
  position: fixed;
  top: var(--navbar-height);
  left: 0;
  background: var(--bg-surface);
  border-right: 1px solid var(--border);
  display: flex;
  flex-direction: column;
  overflow-y: auto;
}

.header {
  padding: var(--space-lg);
  border-bottom: 1px solid var(--border);
  display: flex;
  align-items: center;
  gap: var(--space-sm);
}

.headerIcon {
  color: var(--accent-cyan);
  font-size: var(--text-lg);
}

.headerText {
  font-family: var(--font-heading);
  font-size: var(--text-xs);
  letter-spacing: 3px;
  color: var(--accent-cyan);
}

.nav {
  flex: 1;
  padding: var(--space-md) 0;
}

.section {
  padding: 0 var(--space-sm);
}

.sectionTitle {
  font-family: var(--font-heading);
  font-size: 10px;
  letter-spacing: 2px;
  color: var(--text-muted);
  padding: var(--space-sm) var(--space-sm);
  margin-bottom: var(--space-xs);
}

.item {
  display: flex;
  align-items: center;
  gap: var(--space-sm);
  padding: var(--space-sm) var(--space-md);
  border-radius: var(--radius-sm);
  color: var(--text-secondary);
  text-decoration: none;
  transition: all var(--transition-fast);
  margin-bottom: 2px;
  border: 1px solid transparent;
}

.item:hover {
  background: var(--bg-elevated);
  color: var(--text-primary);
  border-color: var(--border);
}

.item.active {
  background: var(--glow-cyan);
  color: var(--accent-cyan);
  border-color: var(--border-accent);
}

.icon {
  font-size: var(--text-base);
}

.label {
  flex: 1;
  font-size: var(--text-sm);
}

.count {
  font-family: var(--font-code);
  font-size: var(--text-xs);
  color: var(--text-muted);
  background: var(--bg-elevated);
  padding: 2px 6px;
  border-radius: var(--radius-sm);
}

.item.active .count {
  background: rgba(0, 240, 255, 0.2);
  color: var(--accent-cyan);
}

.footer {
  padding: var(--space-md);
  border-top: 1px solid var(--border);
  text-align: center;
}

.version {
  font-family: var(--font-code);
  font-size: var(--text-xs);
  color: var(--text-muted);
}

@media (max-width: 768px) {
  .sidebar {
    display: none;
  }
}
